import { render, staticRenderFns } from "./CaseInformationModal.vue?vue&type=template&id=5c909056&scoped=true"
import script from "./CaseInformationModal.vue?vue&type=script&lang=js"
export * from "./CaseInformationModal.vue?vue&type=script&lang=js"
import style0 from "./CaseInformationModal.vue?vue&type=style&index=0&id=5c909056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c909056",
  null
  
)

export default component.exports